export function extractCoins(data) {
  if (!data) return null;
  const candidates = [
    data?.user?.coins,
    data?.user?.coin,
    data?.user?.userCoins,
    data?.user?.remainingCoins,
    data?.user?.remaining_coin,

    data?.coins,
    data?.coin,
    data?.userCoins,
    data?.remainingCoins,
    data?.remaining_coin,
    data?.result?.coins,
    data?.result?.userCoins,
    data?.data?.coins,
    data?.data?.userCoins,
  ];

  for (const v of candidates) {
    const n = Number(v);
    if (Number.isFinite(n)) return n;
  }
  return null;
}


